<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      :clipped="$vuetify.breakpoint.mdAndUp"
      color="#222A30"
      width="220"
      dark
      app>
      <v-list dense nav>
        <template v-for="item in menus">
            <v-row
              v-if="item.heading"
              :key="item.heading"
              align="center"
              >
              <v-col cols="6">
                <v-subheader v-if="item.heading">
                  {{ item.heading }}
                </v-subheader>
              </v-col>
              <v-col
                cols="6"
                class="text-center">
                <a
                  href="#!"
                  class="body-2 black--text"
                >EDIT</a>
              </v-col>
            </v-row>
            <v-list-group
              v-else-if="item.children"
              :key="item.title"
              v-model="item.model"
              :append-outer-icon="item.model ? item.icon : item['icon-alt']"
              :prepend-icon="item.main_icon">
              <template v-slot:activator>
                <v-list-item class="pl-0">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                link
                >
                <v-list-item-action v-if="child.icon" @click.prevent="child.action">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content @click.prevent="child.action">
                  <v-list-item-title>
                    {{ child.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-else
              :key="item.title"
              link
              @click.prevent="item.action">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-divider v-if="isShow"></v-divider>
          <v-list-item
              link
              @click.prevent="users"
              v-if="isShow"
              >
              <v-list-item-action>
                <v-icon>people</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Users
                </v-list-item-title>
              </v-list-item-content>
          </v-list-item>

          <!-- <v-list-item
              link
              @click.prevent="insights"
              v-if="isShow"
              >
              <v-list-item-action>
                <v-icon>control_camera</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Discover Insights
                </v-list-item-title>
              </v-list-item-content>
          </v-list-item> -->

          <v-list-item
              link
              @click.prevent="channelUpdator"
              v-if="isShow"
              >
              <v-list-item-action>
                <v-icon>queue_music</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  Channels
                </v-list-item-title>
              </v-list-item-content>
          </v-list-item>
          
      </v-list>

      <v-toolbar style="position:absolute; bottom: 0px; left:0px; right: 0px;" dense>
        <v-toolbar-items>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="profile" v-on="on">
                <v-icon>fa-user</v-icon>
              </v-btn>
            </template>
            <span>Profile</span>
          </v-tooltip>

           <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="quickStart" v-on="on" class="ml-4">
                <v-icon>fa-rocket</v-icon>
              </v-btn>
            </template>
            <span>Quick Start</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon @click="logout" v-on="on">
                <v-icon>fa-sign-out-alt</v-icon>
              </v-btn>
            </template>
            <span>Logout</span>
          </v-tooltip>
          
        </v-toolbar-items>
      </v-toolbar>

    </v-navigation-drawer>

    <v-app-bar app
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      color="#0f4e74"
      height="50"
      dark
      flat
      class="pl-4"
      >
      <img src="../assets/logo_new.png" width="150px" @click.stop="home">
      <div v-if="$vuetify.breakpoint.smAndUp" style="margin-left: 10px;" @click="timezonChooser">{{ ' '}}  Current Time: {{ cTime }} {{(dst==1)?getTimezoneAbbr():'MST'}}</div>
      <v-spacer></v-spacer>
      <v-toolbar-items >
        <v-tooltip bottom>
          <span>Switch User</span>
          <template v-slot:activator="{on}">
            <v-btn v-on="on" text style="text-transform: none;" @click="userSelect = !userSelect">Working as ({{type}}) : {{selectedUserEmail? selectedUserEmail:appuser.email}}</v-btn>
          </template>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{on}">
            <v-btn icon @click="backToAdmin" v-on="on"><v-icon>settings_backup_restore</v-icon></v-btn>
          </template>
          <span>Work as Admin</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-app-bar>


    <v-dialog v-model="dialog" max-width="350">
      <v-card tile>
        <v-card-title>Setting / Timezone</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-for="(timezon, index) in timezons" 
                :key="index"
                class="mt-0"
                v-model="timezon.checked"
                dense
                :label="timezon.dname"
                @click="timezonChange(timezon.name, timezon.dst)"
                ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" tile @click.prevent="dialog = !dialog">Cancel</v-btn>
          <v-btn color="primary" tile @click="saveUserTimezone">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog 
    max-width="350"
    v-model="channelUpdate">
      <v-card>
        <v-card-title>Manually update channels</v-card-title>
        <v-card-text class="">
          <p v-if="!isImporting">Last channel update was:<br><b>{{channel_updated_at}}</b></p>
          <p v-if="!isImporting">Last channel count was:<br><b>{{totalChannel}}</b></p>
          <v-row
            v-if="isImporting"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col
              class="subtitle-1 text-center"
              cols="12"
            >
              Importing your channels
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                color="primary accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" v-if="!isImporting" @click="channelUpdate=false" tile>Close</v-btn>
          <v-btn color="primary" tile v-if="!isImporting" @click="updateChannel">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="userSelect" width="500">
      <v-card tile>
        <v-card-title>Switch User</v-card-title>
        <v-spacer></v-spacer>
        <v-card-text>
          <v-autocomplete
            :items="allusers"
            item-text="email"
            v-model="appuser"
            return-object
            @change="changeUser"
            ></v-autocomplete>
            <v-col class="title">Name: {{appuser.name}}</v-col>
            <v-col class="title">Email: {{appuser.email}}</v-col>
            <v-col class="title">Phone: {{appuser.phone}}</v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" tile @click="setAppUser">Switch User</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from './axios'
import moment from 'moment'
import mtz from 'moment-timezone'
import timezon from '../../../timezons'
import EventBus from '../../../eventbus'
export default {
    data(){
        return {
          mini: false,
          dst: 1,
          isImporting: false,
          userSelect:false,
          selectedUserEmail: null,
          isShow:1,
          totalChannel: 0,
          channel_updated_at: '1 minute ago',
          channelUpdate: false,
          timezons: timezon,
          cTime: localStorage.getItem("timezone") ? moment(moment().tz(this.$store.getters.getTimezone).format('MM/DD/YYYY HH:mm'), 'MM/DD/YYYY HH:mm').utc().format('MM-DD-YYYY LT') : moment().tz(this.$store.getters.getTimezone).format('MM-DD-YYYY LT'),
          dialog: false,
          loggedInUser: this.$store.getters.getUser,
          selectedTimezone: this.$store.getters.getTimezone,
          type: 'Admin',
          drawer: true,
          isAdmin: false,
          timezoneChanger: null,
          allusers:[],
          menus:[
              {title: 'Radios', icon: 'radio', action: this.radios},
              {title: 'Schedules', icon: 'today', action:()=>{this.$router.push('/admin/schedules').catch(()=>{})}},
              // {title: 'Schedules', icon: 'today', action:()=>{this.$router.push('/admin/schedule').catch(()=>{})}},
              {title: 'Messages', icon: 'fa-microphone', action:()=>{this.$router.push('/admin/messages').catch(()=>{})}},
              {title: 'Message Playlist', icon: 'queue_music', action: ()=>{this.$router.push('/admin/playlist').catch(()=>{})}},
              {title: 'Timezone', icon: 'fa-clock', action: this.timezonselector}
          ],
          appuser:{
            id: this.$store.getters.getUser,
            name: 'Admin',
            email: this.$store.getters.getEmail,
            isAdmin: 1
          }
        }
    },
    methods:{
      updateChannel(){
      this.isImporting = true
      axios.get('import-channel?token='+this.$store.getters.getToken)
        .then(response=>{
          this.channel_updated_at = response.data.updated_at
          this.totalChannel = response.data.total
          this.isImporting = false
        })
        .catch(error=>{
          this.isImporting= false
        })
      },
      channelUpdator(){
        this.channelUpdate = true
      },
      timezonChooser(){
        this.timezons.forEach(timezone=>{
            if(timezone.name == localStorage.getItem('timezone') && timezone.dst == localStorage.getItem('dst')){
              timezone.checked = 1
            }else{
              timezone.checked = 0
            }
          })
        this.dialog = true
      },
      timezonChange(timezon, dst){
          this.timezons.forEach(timezone=>{
            if(timezone.name == timezon && timezone.dst == dst){
              timezone.checked = 1
              this.dst = dst
            }else{
              timezone.checked = 0
            }
          })

          this.selectedTimezone = timezon
      },
      currentTime(){
        return moment().tz(this.$store.getters.getTimezone).format('MM-DD-YYYY LT')
      },
      getTimezoneAbbr(){
        return mtz().tz(this.$store.getters.getTimezone).format('zz')
      },
      changeUser(user){
        this.appuser = user
      },
      changedUser(){
        console.log('change user fired.')
      },
      // setAppUser(){
      //   this.$store.dispatch('setUser', this.appuser.id)
      //   if(this.appuser.timezone == "" || this.appuser.timezone == null){
      //     this.appuser.timezone = 'UTC'
      //   }
      //   this.$store.dispatch('setUserTimezone', this.appuser.timezone)
      //   this.selectedTimezone = this.$store.getters.getTimezone
      //   localStorage.setItem('timezone', this.appuser.timezone)
      //   this.userSelect = false
      //   this.selectedUserEmail = this.appuser.email
      //   this.$store.dispatch('setAlert', 'You are working as '+this.appuser.name)

      //   this.$router.push('/admin/radios/'+this.appuser.id)
      // },
      setAppUser(){
        this.$store.dispatch('setUser', this.appuser.id)
        if(this.appuser.timezone == "" || this.appuser.timezone == null){
          this.appuser.timezone = 'UTC'
        }
        this.$store.dispatch('setUserTimezone', this.appuser.timezone)
        this.selectedTimezone = this.$store.getters.getTimezone
        localStorage.setItem('timezone', this.appuser.timezone)
        this.userSelect = false
        this.selectedUserEmail = this.appuser.email
        this.$store.dispatch('setAlert', 'You are working as '+this.appuser.name)
        if(this.appuser.isAdmin == 1){
          this.isShow = 1
          this.type = 'Admin'
          this.$store.dispatch('setWorkingAs', 1)
        }else{
          this.isShow = 0
          this.type = 'User'
          this.$store.dispatch('setWorkingAs', 0)
        }
        this.$router.push('/admin/radios/'+this.appuser.id)
      },
      schedules(){
         localStorage.setItem('scheduleId', 0)
         this.$router.push('/admin/schedules').catch(()=>{})
      },
      scheduleManage(){
        this.$router.push('/admin/schedule-manage').catch(()=>{})
      },
      scheduleAdd(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/admin/schedule-add').catch(()=>{})
      },
      home(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/admin/radios').catch(()=>{})
      },
      logout(){
        this.$store.dispatch('logout')
        this.$router.push('/').catch(()=>{})
      },
      profile(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/admin/profile').catch(()=>{})
      },
      radios(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/admin/radios').catch(()=>{})
      },
      radio_status(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/admin/radio-status').catch(()=>{})
      },
      quickStart(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/admin/quick-start').catch(()=>{})
      },
      help(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/admin/help').catch(()=>{})
      },
      users(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/admin/users').catch(()=>{})
      },
      insights(){
        localStorage.setItem('scheduleId', 0)
        this.$router.push('/admin/console').catch(()=>{})
      },
      backToAdmin(){
        let admin = this.allusers.filter(r=>{
          return r.id == this.loggedInUser
        })
        localStorage.setItem('scheduleId', 0)
        this.appuser = Object.assign({}, admin[0])
        this.setAppUser()
      },
      timezonselector(){
        this.timezons.forEach(timezone=>{
            if(timezone.name == localStorage.getItem('timezone') && timezone.dst == localStorage.getItem('dst')){
              timezone.checked = 1
            }else{
              timezone.checked = 0
            }
          })
        this.dialog = true
      },
      saveUserTimezone(){
        let user = {
          timezone: this.selectedTimezone,
          user_id: this.$store.getters.getUser,
          dst: this.dst
        }
        axios.post('change-timezone', user,{
                params:{
                    token: this.$store.getters.getToken,
                    user_id: this.$store.getters.getUser
                }
              })
              .then(response=>{
                this.$store.dispatch('setAlert', 'Timezone has been changed.')
                localStorage.setItem('timezone', this.selectedTimezone)
                localStorage.setItem('dst', this.dst)
                this.$store.dispatch('setUserTimezone', this.selectedTimezone)
                this.dialog = false
               
                if(this.dst){
                  this.cTime = moment().tz(this.$store.getters.getTimezone).format('MM-DD-YYYY LT')
                }else{
                  this.cTime = moment().tz('US/Pacific').format('MM-DD-YYYY LT')
                }
                
              })
              .catch(error=>{
                this.$store.dispatch('setErrorAlert', 'There is an error.')
              })
        
      }
    },
    created(){
      EventBus.$on('changeuser', this.changeUser)
      EventBus.$on('setappuserevent', this.setAppUser)

      axios.get('users',{
          params:{
            token: this.$store.getters.getToken,
            user_id: this.$store.getters.getUser
          }
        })
        .then(response=>{ 
            this.allusers = response.data.users
        })
        .catch(e=>{
          this.$store.dispatch('setErrorAlert', e.response.data.message)
        })


      axios.get('channel-update-status?token='+ this.$store.getters.getToken)
      .then(response=>{
        this.channel_updated_at = response.data.updated_at
        this.totalChannel = response.data.total
      })
      .catch(error=>{
        this.$store.dispatch('setErrorAlert', error.response.data.message)
      })

       this.timezons.forEach(timezone=>{
            if(timezone.name == this.$store.getters.getTimezone){
              timezone.checked = 1
            }else{
              timezone.checked = 0
            }
        })

      this.dst = localStorage.getItem('dst')

      if(this.dst){
        this.cTime = moment().tz(this.$store.getters.getTimezone).format('MM-DD-YYYY LT')
      }else{
        this.cTime = moment().tz('US/Pacific').format('MM-DD-YYYY LT')
      }

      if(this.timezoneChanger){
          clearInterval(this.timezoneChanger)
      }

      this.timezoneChanger = setInterval(()=>{
          this.cTime = moment().tz(this.$store.getters.getTimezone).format('MM-DD-YYYY LT')
      }, 10000)
    },
    beforeDestroy(){
      EventBus.$off('changeuser', this.changeUser)
      EventBus.$off('setappuserevent', this.setAppUser)
        if(this.timezoneChanger){
            clearInterval(this.timezoneChanger)
        }
    }
}
</script>

<style scoped>
.v-application .primary--text {
    color: #e2e8ef !important;
    caret-color: #ecf0f3 !important;
}
.v-list-group__header__prepend-icon{
  margin-right: 40px;
}
</style>